import { Route, Routes } from 'react-router-dom';
import Main from './Main';
import { Suspense } from 'react';

function App() {
  return (
    <>
      <Suspense fallback={<h2>Loading...</h2>
      }>
        <Routes>
          <Route path="/" element={<Main />} />
        </Routes>
      </Suspense>
    </>
    
  );
}

export default App;
